import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'
import { useHistory } from 'react-router'

import NotificationBanner from 'components/NotificationBanner'

import { ReactComponent as MedicalEvaluationIcon } from 'static/svg/medical-evaluation-icon.svg'
import { ReactComponent as WatchIcon } from 'static/svg/watch-icon.svg'

import { DASHBOARD_PATIENT_MEDICAL_EVALUATION } from 'settings/_routesSettings'

import * as S from './styles'

const MedicalEvaluationNotificationBanner = (): JSX.Element => {
  const history = useHistory()

  return (
    <NotificationBanner 
      title='É hora de fazer a sua avaliação de saúde emocional!'
      description='Ela é muito importante para que possamos te acompanhar e auxiliar na sua evolução, além de ter mais informações sobre a eficácia do programa.'
      buttonText='Fazer avaliação'
      onButtonClick={() => history.push(DASHBOARD_PATIENT_MEDICAL_EVALUATION)}
      icon={<MedicalEvaluationIcon />}
      actionDisclaimer={
        <S.DisclaimerContainer>
          <WatchIcon />
          <Typography 
            variant='content2'
            customClassName='DisclaimerContainer__Text'
          >
            Leva 7 min
          </Typography>
        </S.DisclaimerContainer>
      }
      showAction
    />
  )
}

export default MedicalEvaluationNotificationBanner